import _ from "lodash";
import { PureComponent, ReactNode } from "react";

export interface TableViewWrapperProps {
  style?: any;
  scrollable?: boolean;
}

interface TableViewWrapperState {}

export class TableViewWrapper extends PureComponent<TableViewWrapperProps, TableViewWrapperState> {
  constructor(props: TableViewWrapperProps) {
    super(props);
    this.state = {};
  }

  getStyle = (): any => {
    let result: any = {};
    if (this.props.style) {
      result = _.clone(this.props.style);
    }
    result.borderCollapse = "collapse";
    if (result?.display) {
      delete result.display;
    }
    if (this.props.scrollable) {
      result.minWidth = "max-content";
    }
    result.height = "100%";
    return result;
  };

  render(): ReactNode {
    return <table className="kuika-table-view-wrapper" {...this.props} style={this.getStyle()} />;
  }
}
